import type { PromoProps } from '../Promo';
import { Content, Icon, Subtitle, Title, Wrapper } from '../Promo';
import TutorialSkeleton from './TutorialSkeleton';
import videoIcon from './assets/static/video.svg';
import { Container, TriggerElement, TriggerWrapper } from './styles';
import useVideoTutorial from './useVideoTutorial';

export { wistiaOverrideStyles } from './styles';

export type TutorialProps = Partial<PromoProps> & {
    videoHash: string;
};

const Tutorial = ({ videoHash, title = 'Video tutorial', subtitle }: TutorialProps) => {
    const { mainScript, video, videoClassName } = useVideoTutorial(videoHash);
    const skeleton = mainScript.loading || video.loading;

    if (skeleton || mainScript.error || video.error) {
        return <TutorialSkeleton loading={skeleton} />;
    }

    return (
        <Container>
            <TriggerWrapper className={videoClassName}>
                <TriggerElement type="button" />
            </TriggerWrapper>
            <Wrapper gap={2}>
                <Icon alt={subtitle} src={videoIcon} />
                <Content>
                    <Title>{title}</Title>
                    {subtitle && <Subtitle>{subtitle}</Subtitle>}
                </Content>
            </Wrapper>
        </Container>
    );
};

export default Tutorial;
